import { Mark, mergeAttributes } from "@tiptap/core"

const FONT_SIZE_PATTERN = /^(?:\d+(?:\.\d+)?|\.\d+)(?:px|pt|em|rem|%)$/i
const FONT_SIZE_KEYWORDS = new Set([
  "xx-small",
  "x-small",
  "small",
  "medium",
  "large",
  "x-large",
  "xx-large",
  "xxx-large",
  "smaller",
  "larger",
])

const normalizeFontSize = (value: unknown) => {
  const fontSize = String(value || "").trim().toLowerCase()
  if (!fontSize) return null

  return FONT_SIZE_PATTERN.test(fontSize) || FONT_SIZE_KEYWORDS.has(fontSize)
    ? fontSize
    : null
}

/** Keeps inline font sizes supplied by external rich-text clipboard HTML. */
export const FontSize = Mark.create({
  name: "fontSize",

  addAttributes() {
    return {
      size: {
        default: null,
        parseHTML: (element) => normalizeFontSize(element.style.fontSize),
        renderHTML: ({ size }) => {
          const fontSize = normalizeFontSize(size)
          return fontSize ? { style: `font-size: ${fontSize}` } : {}
        },
      },
    }
  },

  parseHTML() {
    return [
      {
        style: "font-size",
        getAttrs: (value) => {
          const fontSize = normalizeFontSize(value)
          return fontSize ? { size: fontSize } : false
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes), 0]
  },
})
